// Liens d'authentification reçus par email (invitation, réinitialisation).
//
// Supabase renvoie l'utilisateur sur le site avec les jetons dans le fragment
// d'URL (#access_token=…&type=invite|recovery). supabase-js consomme ce
// fragment et ouvre la session, mais rien n'oblige ensuite l'utilisateur à
// choisir un mot de passe. On lit donc le `type` AVANT que le fragment soit
// consommé, et on le mémorise le temps d'afficher l'écran « définir un mot de
// passe ».
const KEY = "crm.pendingAuthLink";

export type PendingLink = "invite" | "recovery" | "magiclink" | null;

export function captureAuthLinkFromUrl(): void {
  const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : "";
  const params = new URLSearchParams(hash);
  const type = params.get("type");
  if (type === "invite" || type === "recovery" || type === "magiclink") {
    try { sessionStorage.setItem(KEY, type); } catch { /* stockage indisponible : on continue sans */ }
  }
}

export function pendingAuthLink(): PendingLink {
  try { return (sessionStorage.getItem(KEY) as PendingLink) ?? null; } catch { return null; }
}

export function clearPendingAuthLink(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
